/**
 * User-facing labels for enum values, in UK English. The single place the UI
 * gets these from, so wording stays consistent across screens.
 */
import type {
  BikeStatus,
  BikeType,
  ComponentCategory,
  InstallPosition,
  JobPriority,
  JobStatus,
} from './enums'

export const bikeTypeLabel: Record<BikeType, string> = {
  mtb_full: 'Full-suspension MTB',
  mtb_hardtail: 'Hardtail MTB',
  mtb_rigid: 'Rigid MTB',
  gravel: 'Gravel',
  road: 'Road',
  cx: 'Cyclocross',
  commuter: 'Commuter',
  ebike: 'E-bike',
  bmx: 'BMX',
  other: 'Other',
}

export const bikeStatusLabel: Record<BikeStatus, string> = {
  active: 'Riding',
  stored: 'Stored',
  building: 'Being built',
  sold: 'Sold',
  retired: 'Retired',
}

export const componentCategoryLabel: Record<ComponentCategory, string> = {
  frame: 'Frame',
  fork: 'Fork',
  shock: 'Rear shock',
  wheel: 'Wheel',
  hub: 'Hub',
  rim: 'Rim',
  tyre: 'Tyre',
  inner_tube: 'Inner tube',
  chain: 'Chain',
  cassette: 'Cassette',
  chainring: 'Chainring',
  crankset: 'Crankset',
  bottom_bracket: 'Bottom bracket',
  derailleur_rear: 'Rear derailleur',
  derailleur_front: 'Front derailleur',
  shifter: 'Shifter',
  brake: 'Brake',
  brake_pads: 'Brake pads',
  brake_rotor: 'Brake rotor',
  headset: 'Headset',
  stem: 'Stem',
  handlebar: 'Handlebar',
  grips: 'Grips',
  seatpost: 'Seatpost',
  saddle: 'Saddle',
  pedals: 'Pedals',
  cables: 'Cables and housing',
  sealant: 'Tubeless sealant',
  other: 'Other',
}

export const installPositionLabel: Record<InstallPosition, string> = {
  front: 'Front',
  rear: 'Rear',
  none: '',
}

export const jobPriorityLabel: Record<JobPriority, string> = {
  safety: 'Safety',
  normal: 'Normal',
  low: 'Low',
}

export const jobStatusLabel: Record<JobStatus, string> = {
  open: 'To do',
  in_progress: 'On the stand',
  done: 'Done',
  cancelled: 'Cancelled',
}
